import { MutableRefObject, useEffect } from 'react';

export default <TElement extends Element>(
  callback: (isIntersecting: boolean) => void,
  ref: MutableRefObject<TElement | null>,
  topOnly?: boolean,
) => {
  useEffect(() => {
    const intersectionCallback = (entries: IntersectionObserverEntry[]) => {
      const isIntersecting = entries[0].isIntersecting;
      const rect = entries[0].boundingClientRect;
      callback(isIntersecting || (!!topOnly && rect.y <= 0 && rect.width > 0));
    };

    if (ref.current) {
      const observer = new IntersectionObserver(intersectionCallback, { threshold: 1 });
      observer.observe(ref.current);
      return () => (ref.current ? observer.unobserve(ref.current) : undefined);
    }
  }, [ref.current]);
};
